import React, { useContext, useEffect, useState } from "react";
import {
  buscarAssociadoPorId,
  buscarParceiroPorUsuario,
} from "../../services/api-planejamento-tributario.service";
import {
  Typography,
  Box,
  IconButton,
  Paper,
  Grid,
  Modal,
  TextField,
  Button,
} from "@mui/material";
import styles from "./styles.module.css";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import ResponsivContent from "../../components/ResponsivContent";
import BadgeIcon from "@mui/icons-material/Badge";
import { LoginContext } from "../../config/Context/LoginContext";

const DashboardDados = () => {
  useEffect(() => {
    const fetchData = async () => {
      await handleSearchData();
    };
    fetchData();
  }, []);

  const handleDownload = (buffer, fileName, contentType) => {
    if (contentType) {
      // console.log(buffer);
      const url = buffer; // Cria URL base64
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();

      URL.revokeObjectURL(url); // Limpar a URL temporária

      //ANTIGO
      // Cria um Blob a partir do buffer
      // const blob = new Blob([buffer.data], {
      //   type: "application/octet-stream",
      // });

      // // Cria um URL para o Blob
      // const url = URL.createObjectURL(blob);

      // // Cria um link de download e simula um clique nele
      // const link = document.createElement("a");
      // link.href = url;
      // link.setAttribute("download", fileName);
      // document.body.appendChild(link);
      // link.click();

      // // Remove o link e revoga o URL para liberar memória
      // document.body.removeChild(link);
      // URL.revokeObjectURL(url);
    } else {
      return;
    }
  };

  const [openModal, setOpenModal] = useState(false);
  const [isEditModal, setIsEditModal] = useState(false);
  const { dadosLogin } = useContext(LoginContext);
  const handleOpen = (titleModalParam, propertiesParam, isEditModalParam) => {
    setTitleModal(titleModalParam);
    setProperties(propertiesParam);
    setIsEditModal(isEditModalParam);
    setOpenModal(true);
  };

  const handleClose = () => setOpenModal(false);

  // #region Informações do modal
  const [titleModal, setTitleModal] = useState("");
  const [properties, setProperties] = useState([]);
  const [dados, setDados] = useState({
    lista: [
      {
        title: "",
        properties: [{ prop: "", value: "" }],
      },
    ],
  });

  const handleSearchData = async () => {
    const tipoCadastroPlanTribKey = dadosLogin.tipoCadastroPlanTribKey;
    let values = "";
    let dados = "";
    if (tipoCadastroPlanTribKey === "A") {
      const response = await buscarAssociadoPorId();
      dados = "dadosAssociado";
      values = response;
    } else {
      dados = "dadosParceiro";
      const response = await buscarParceiroPorUsuario();
      values = response;
    }

    setDados({
      lista: [
        {
          title: `Dados do ${tipoCadastroPlanTribKey === "A" ? "Associado" : "Parceiro"}`,
          properties: [
            { prop: "Nome", value: values.data[dados].nome },
            { prop: "CEP", value: values.data[dados].cep },
            { prop: "Logradouro", value: values.data[dados].logradouro },
            { prop: "Bairro", value: values.data[dados].bairro },
            { prop: "Número", value: values.data[dados].numero },
            {
              prop: "Complemento",
              value: values.data[dados].complemento,
            },
            { prop: "Cidade", value: values.data[dados].cidade },
            { prop: "Estado", value: values.data[dados].estado },
            { prop: "País", value: values.data[dados].pais },
            { prop: "RG", value: values.data[dados].rg },
            { prop: "CPF", value: values.data[dados].cpf },
            { prop: "E-mail", value: values.data[dados].email },
            { prop: "Telefone", value: values.data[dados].telefone },
            { prop: "WhatsApp", value: values.data[dados].whatsapp },
          ],
        },
        {
          title: "Resp. empresa",
          properties: [
            { prop: "Nome", value: values.data.responsavelEmpresa.nome },
            {
              prop: "Profissão",
              value: values.data.responsavelEmpresa.profissao,
            },
            {
              prop: "Estrangeiro",
              value: values.data.responsavelEmpresa.estrangeiro,
            },
            {
              prop: "Tipo de documento",
              value: values.data.responsavelEmpresa.tipoDocumento,
            },
            {
              prop: "Documento",
              value: values.data.responsavelEmpresa.documento,
            },
            {
              prop: "Ramo de atividade",
              value: values.data.responsavelEmpresa.ramo,
            },
            { prop: "E-mail", value: values.data.responsavelEmpresa.email },
            { prop: "Nº OAB", value: values.data.responsavelEmpresa.oab },
            { prop: "CRC", value: values.data.responsavelEmpresa.crc },
            { prop: "Telfone", value: values.data.responsavelEmpresa.telefone },
            {
              prop: "WhatsApp",
              value: values.data.responsavelEmpresa.whatsapp,
            },
            {
              prop: "Alguém indicou",
              value: values.data.responsavelEmpresa.foiIndicado,
            },
            {
              prop: "Indicado por",
              value: values.data.responsavelEmpresa.indicadoPor,
            },
          ],
        },
        {
          title: "Resp. Financeiro",
          properties: [
            { prop: "Nome", value: values.data.responsavelFinanceiro.nome },
            { prop: "E-mail", value: values.data.responsavelFinanceiro.email },
            { prop: "CPF", value: values.data.responsavelFinanceiro.cpf },
            {
              prop: "Telefone",
              value: values.data.responsavelFinanceiro.telefone,
            },
            {
              prop: "WhatsApp",
              value: values.data.responsavelFinanceiro.whatsapp,
            },
          ],
        },
        {
          title: "Resp. Legal",
          properties: [
            { prop: "Nome", value: values.data.responsavelLegal.nome },
            { prop: "E-mail", value: values.data.responsavelLegal.email },
            { prop: "CPF", value: values.data.responsavelLegal.cpf },
            { prop: "Telefone", value: values.data.responsavelLegal.telefone },
            { prop: "WhatsApp", value: values.data.responsavelLegal.whatsapp },
          ],
        },
        {
          title: "Procurador",
          properties: [
            { prop: "Nome", value: values.data.procurador.nome },
            { prop: "E-mail", value: values.data.procurador.email },
            { prop: "CPF", value: values.data.procurador.cpf },
            { prop: "Telefone", value: values.data.procurador.telefone },
            { prop: "WhatsApp", value: values.data.procurador.whatsapp },
          ],
        },
        {
          title: "Dados bancários",
          properties: [
            { prop: "Banco", value: values.data.dadosBancarios.banco },
            { prop: "Agência", value: values.data.dadosBancarios.agencia },
            { prop: "Conta", value: values.data.dadosBancarios.conta },
            { prop: "PIX", value: values.data.dadosBancarios.pix },
          ],
        },
      ],
    });
  };

  return (
    <>
      <ResponsivContent>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            alignSelf: "flex-start",
            width: "100%",
          }}
        >
          <BadgeIcon
            sx={{
              color: "#18316e",
              fontSize: "2rem",
            }}
          />
          <h1
            style={{
              fontFamily: "Abhaya Libre",
              color: "#18316e",
              fontSize: "2rem",
              marginLeft: "1rem",
            }}
          >
            Meus Dados
          </h1>
        </div>
        <div
          style={{
            maxHeight: "24rem",
            overflowY: "scroll",
            margin: "0.5rem",
          }}
        >
          <Grid container spacing={2}>
            {dados.lista.map((dado, index) => (
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  transition: "transform 0.3s ease-in-out",
                  "&:hover": {
                    transform: "scale(0.95)",
                  },
                }}
              >
                <Paper
                  key={index}
                  className={styles.paperChamadaForm}
                  elevation={3}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography className={styles.textoChamadaForm}>
                      {dado.title}
                    </Typography>
                    <Box sx={{ wrap: "no-wrap" }}>
                      <IconButton
                        aria-label="visualizar"
                        onClick={() =>
                          handleOpen(dado.title, dado.properties, false)
                        }
                      >
                        <VisibilityIcon className={styles.iconeVerEditar} />
                      </IconButton>
                      <IconButton
                        aria-label="editar"
                        onClick={() =>
                          handleOpen(dado.title, dado.properties, true)
                        }
                      >
                        <EditIcon className={styles.iconeVerEditar} />
                      </IconButton>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </div>
      </ResponsivContent>

      {/* Modal */}
      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          margin: "1rem",
        }}
      >
        <Box
          sx={{
            width: 400,
            p: 3,
            backgroundColor: "#fff",
            borderRadius: "0.5rem",
          }}
        >
          <Typography
            id="modal-title"
            variant="h6"
            sx={{ fontFamily: "Inter", color: "#18316e" }}
          >
            {titleModal}
          </Typography>
          <div
            className={styles.divProperties}
            style={{ maxHeight: "24rem", overflowY: "scroll" }}
          >
            {properties.map((propertie, index) =>
              !isEditModal ? (
                <div key={index}>
                  <Typography
                    id="modal-description"
                    sx={{
                      marginTop: "0.7rem",
                      fontFamily: "Inter",
                      color: "#18316e",
                      textAlign: "left",
                    }}
                  >
                    <span style={{ fontWeight: "500" }}>{propertie.prop}</span>:
                    <span style={{ fontWeight: "300", color: "#898989" }}>{` ${propertie.value}`}</span>
                    {titleModal === "Docs. Anexados" &&
                    propertie.value.arquivo ? (
                      <span
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "#18316e",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          handleDownload(
                            propertie.value.arquivo,
                            propertie.value.nomeDoArquivo,
                            propertie.value.contentType
                              ? propertie.value.contentType
                              : null
                          )
                        }
                      >
                        <IconButton
                          aria-label="download"
                          sx={{ color: "#898989" }}
                        >
                          <CloudDownloadIcon />
                        </IconButton>
                        <span
                          style={{ marginLeft: "0.2rem", color: "#898989" }}
                        >
                          {propertie.value.nomeDoArquivo}
                        </span>
                      </span>
                    ) : (
                      ""
                    )}
                  </Typography>
                </div>
              ) : (
                <TextField
                  key={index}
                  sx={{
                    marginTop: "0.7rem",
                    fontFamily: "Inter",
                    color: "#18316e",
                    textAlign: "left",
                  }}
                  fullWidth
                  size="small"
                  label={propertie.prop}
                  value={propertie.value}
                />
              )
            )}
          </div>

          {isEditModal ? (
            <Button
              sx={{
                color: "#fff",
                backgroundColor: "#18316e",
                fontFamily: "Inter",
                transition: "transform 0.3s ease-in-out",
                marginTop: "1rem",
                "&:hover": {
                  transform: "scale(0.95)",
                  backgroundColor: "#18316e",
                },
              }}
              onClick={handleClose}
              fullWidth
            >
              Salvar
            </Button>
          ) : null}
          <Button
            sx={{
              border: "1px solid",
              color: "#18316e",
              fontFamily: "Inter",
              transition: "transform 0.3s ease-in-out",
              marginTop: "1rem",
              "&:hover": {
                transform: "scale(0.95)",
              },
            }}
            onClick={handleClose}
            fullWidth
          >
            Fechar
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default DashboardDados;
